import Button from 'components/Buttons/Button';
import MarkdownContent from 'components/Markdown';
import { consentByLocale } from 'constants/consent';
import { useConsentContext } from 'contexts/ConsentContext';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Locale } from 'types/I18n';

import Modal from '../Modal';
import styles from './ConsentModal.module.scss';

const ConsentModal = () => {
    const { locale } = useIntl();
    const { isOpen, onContinue } = useConsentContext();
    const consentContent = consentByLocale[locale as Locale];
    const contentRef = React.useRef<HTMLDivElement>(null);

    const currentItem = consentContent[0];

    return (
        <Modal
            onClickBackdrop={() => {}}
            isVisible={isOpen}
            classes={{
                root: styles["consent-modal"],
                container: styles["consent-modal__container"],
            }}
        >
            <div className={styles["consent"]}>
                <div
                    className={styles["consent__pic"]}
                    style={{
                        backgroundImage: `url(${currentItem.imageUrl})`,
                    }}
                />
                <div className={styles["consent-container"]}>
                    <div className={styles["div-content"]} ref={contentRef}>
                        <h1 className={styles["content__title"]}>{currentItem.title}</h1>
                        <MarkdownContent
                            content={currentItem.text}
                            className={styles["content__text"]}
                        />
                    </div>
                </div>
                <div className={styles["content__buttons"]}>
                    <Button size="small" onClick={onContinue}>
                        <FormattedMessage id="consent_btn.continue" />
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ConsentModal;
